import React from "react";
import { SonharMorarProps } from "./SonharMorar.types";
import { SonharMorarContainer } from "./SonharMorar.style";
import {
  ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";

export default class SonharMorar extends Container<
  SonharMorarProps,
  CoreContainerState
> {
  constructor(props: SonharMorarProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
    };
  }

  render() {
    const { id } = this.props;
    return (
      <>
        <SonharMorarContainer id={id}>
          {this.childComponents && this.childComponents.length > 0 && (
            <>
              {this.childComponents.length === 3 && (
                <>
                  {this.childComponents.slice(0, 1).map((item, k) => (
                    <div key={k}>{item}</div>
                  ))}
                  <div className="sonharmorar__content">
                    <div>
                      {this.childComponents.slice(1).map((item, k) => (
                        <div key={k}>{item}</div>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {this.childComponents.length > 1 && this.childComponents.length < 3 && (
                <>
                  {this.childComponents.slice(0, 1).map((item, k) => (
                    <div key={k}>{item}</div>
                  ))}
                  <div className="sonharmorar__content">
                    <div>
                      {this.childComponents.slice(1).map((item, k) => (
                        <div key={k}>{item}</div>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {this.childComponents.length === 1 &&
                this.childComponents.map((item, k) => (
                  <div key={k}>{item}</div>
                ))
                }
            </>
          )}
        </SonharMorarContainer>
        {this.childComponents.length < 3 && this.placeholderComponent}
      </>
    );
  }
}
